module.exports = __webpack_public_path__ + "static/Hero-af7e35314a66c1f731f8e9cd13d0b412.svg";